import { Product } from "../../../../sdk/@types";

/**
 * One row of the raw `GET /api/products` payload.
 *
 * This is the catalog document, not a `Plan`. The landing must not read a
 * catalog-merged plan: that merge fills an empty description and turns an
 * unknown day count into "mensal".
 */
export type LandingCatalogProduct = Product.Product;

/** How many eligible plans the landing shows. */
export const LANDING_PLAN_LIMIT = 3;

/** How many feature lines a card lists before the remainder. */
export const LANDING_FEATURE_LIMIT = 3;

/** Details destination when the slug is missing or not unique. */
export const LANDING_PLANS_HREF = "/planos";

/**
 * An eligible product after landing order and the three-plan cut.
 *
 * `popular` is the Mais popular treatment. It is true for at most one row:
 * the first popular plan in landing order. It is not a copy of the raw flag.
 */
export interface SelectedLandingProduct {
  id: string;
  title: string;
  description: unknown;
  price: number;
  amountOfDays: unknown;
  features: unknown;
  popular: boolean;
}

/**
 * One plan the landing may render. Every product string comes from the raw
 * row. There is no exam-cycle field: a year in the title stays inside `title`.
 */
export interface LandingPlan {
  /** Product id from the loaded payload. */
  id: string;
  /** Product title, unchanged. */
  title: string;
  /** Product description, or "" when the product has none. */
  description: string;
  /** Catalog price as a number, not a formatted string. */
  price: number;
  /**
   * "mensal", "trimestral", "semestral", or "anual" for 30, 90, 180, and 365.
   * "Acesso por N dias" for any other positive length.
   * "" when the length is missing or not a positive number — never "mensal".
   */
  periodLabel: string;
  /** The first three product features, in payload order. Empty when there are none. */
  features: string[];
  /** How many features were not listed. Nine features yield 6. */
  featureRemainder: number;
  /** Mais popular treatment. True for at most the first popular plan. */
  popular: boolean;
  /**
   * The slug `/planos` uses for this title: the static catalog slug when the
   * normalized title matches, otherwise the normalized title with spaces
   * replaced by "-". Empty when that derivation is empty.
   */
  slug: string;
  /**
   * `/planos?plano=<slug>` when `slug` is non-empty and unique among every
   * product in the loaded payload. Otherwise `/planos`, with no query.
   */
  href: string;
}
